var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAustralia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_110693)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6042_110693)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.955126 0 2.13333V13.8667C0 15.0449 0.93807 16 2.09524 16H19.9048C21.0619 16 22 15.0449 22 13.8667V2.13333C22 0.955126 21.0619 0 19.9048 0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19043 12.2698L5.23805 11.7365L5.76186 10.6698L6.28567 11.7365L7.33329 12.2698L6.28567 12.8031L5.76186 13.8698L5.23805 12.8031L4.19043 12.2698ZM14.6666 3.20312V4.26979H15.7142V3.20312H14.6666ZM17.8095 4.26979V5.33646H18.8571V4.26979H17.8095ZM13.619 6.40313V7.46979H14.6666V6.40313H13.619ZM16.7619 7.46979V8.53646H17.8095V7.46979H16.7619ZM15.7142 10.6698V11.7365H16.7619V10.6698H15.7142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4288 1.07031H2.09547C1.51689 1.07031 1.04785 1.54788 1.04785 2.13698V7.47031C1.04785 8.05942 1.51689 8.53698 2.09547 8.53698H9.4288C10.0074 8.53698 10.4764 8.05942 10.4764 7.47031V2.13698C10.4764 1.54788 10.0074 1.07031 9.4288 1.07031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23856 5.33281H2.0957V4.26615H5.23856V2.13281H6.28618V4.26615H9.42904V5.33281H6.28618V7.46615H5.23856V5.33281ZM7.85761 6.39948V7.46615H9.42904V6.39948H7.85761ZM7.85761 2.13281V3.19948H9.42904V2.13281H7.85761ZM2.0957 6.39948V7.46615H3.66713V6.39948H2.0957ZM2.0957 2.13281V3.19948H3.66713V2.13281H2.0957Z",
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_110693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6042_110693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAustralia);
export default __webpack_public_path__ + "static/media/icon-australia.1878f99fd16cea05738df426535d4bc7.svg";
export { ForwardRef as ReactComponent };